const letterMatching = {
    а: 'A',
    в: 'B',
    с: 'C',
    е: 'E',
    н: 'H',
    к: 'K',
    м: 'M',
    о: 'O',
    р: 'P',
    т: 'T',
    у: 'Y',
    х: 'X',
};

export const rusToLatGosnumber = function (str) {
    let newStr = [];

    for (let i = 0; i < str.length; ++i) {
        const matching =
            letterMatching[str[i]] || letterMatching[str[i].toLowerCase()];
        if (matching !== undefined) {
            newStr.push(
                matching.replace(/^(.)/, function (match) {
                    return match.toUpperCase();
                })
            );
        } else {
            // Удаление символов кириллицы
            const isCyrillic = /[а-яА-Я]/.test(str[i]);
            if (!isCyrillic) {
                newStr.push(str[i]);
            }
        }
    }

    return newStr.join('');
};
